import { Auth } from "aws-amplify";
import axios from "axios";
import { authHeader } from "../CommonMethods/Auth-Headers";

import { baseURL } from "../config";
async function forgotPassword(url, payload) {
    // payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}${url}`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function resetPassword(link,payload) {
    // payload = JSON.stringify(payload);
    
    try {
        const data = await axios.post(`${baseURL}${link}`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

export const userService = {
    resetPassword,
    forgotPassword,
}
